import { render } from "./sort_options.vue?vue&type=template&id=04a4e8cf&lang=pug"
import script from "./sort_options.vue?vue&type=script&lang=js"
export * from "./sort_options.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__